// extracted by mini-css-extract-plugin
module.exports = {"dayNightShadingContainer":"DayNightShading_dayNightShadingContainer__xNk5q"};